<div class="p-3 pt-2 rounded-4">
    <div>
        <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
            <div class="p-3">Settings</div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row bg-white p-2 pt-0">
            <div class="col-md-12 mt-4 mb-5">
                <table class="table table-bordered mt-5">
                    <thead>
                        <tr class="text-center">
                            <th class="fw-bold w-50 bg-primary text-white" colspan="2">Issuers</th>
                            <th class="fw-bold w-50 bg-danger text-white" colspan="2">Acquirers</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Andaria
                            </td>
                            <td>
                                <div class="form-check form-switch">
                                    <label class="form-check-label" for="andariaApi"></label>
                                    <input class="form-check-input" type="checkbox" role="switch" id="andariaApi"
                                        [checked]="bankStatus.andariaApi" (click)="toggleBank('andariaApi')">
                                </div>
                            </td>
                            <td>
                                HNB
                            </td>
                            <td>
                                <div class="form-check form-switch">
                                    <label class="form-check-label" for="andariaApi"></label>
                                    <input class="form-check-input" type="checkbox" role="switch" id="hnbApi"
                                        [checked]="bankStatus.hnbApi" (click)="toggleBank('hnbApi')">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                HSBC
                            </td>
                            <td>
                                <div class="form-check form-switch">
                                    <label class="form-check-label" for="hsbcApi"></label>
                                    <input class="form-check-input" type="checkbox" role="switch" id="hsbcApi"
                                        [checked]="bankStatus.hsbcApi" (click)="toggleBank('hsbcApi')">
                                </div>
                            </td>
                            <td>
                                OCBC
                            </td>
                            <td>
                                <div class="form-check form-switch">
                                    <label class="form-check-label" for="ocbcApi"></label>
                                    <input class="form-check-input" type="checkbox" role="switch" id="ocbcApi"
                                        [checked]="bankStatus.ocbcApi" (click)="toggleBank('ocbcApi')">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>